import { render, staticRenderFns } from "./EmissionsView.vue?vue&type=template&id=4da18863"
import script from "./EmissionsView.vue?vue&type=script&lang=js"
export * from "./EmissionsView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports